import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent, HTMLAttributes } from 'react';
import { faExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface BrandVetBannerProps {
  onApply?: () => void;
}

const Container: FunctionComponent = ({ children }) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: '20px',
      width: '100%',
      padding: '24px 32px',
      borderRadius: '10px',
      background: '#F5F9FB',
    }}
  >
    {children}
  </Flex>
);

const IconContainer: FunctionComponent = ({ children }) => (
  <Flex
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      width: '44px',
      height: '44px',
      borderRadius: '50%',
      color: 't.blue120',
      background: '#CCE9F0',
      fontWeight: 300,
      fontSize: 'l',
    }}
  >
    {children}
  </Flex>
);

const ContentContainer: FunctionComponent = ({ children }) => (
  <Flex
    sx={{
      position: 'relative',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 's',
    }}
  >
    {children}
  </Flex>
);

const Title: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      fontWeight: 600,
      fontSize: 'H600',
      lineHeight: 'normal',
      color: 't.black80',
    }}
  >
    {children}
  </Box>
);

const Message: FunctionComponent = ({ children }) => (
  <Box
    sx={{
      width: '100%',
      maxWidth: '729px',
      fontWeight: 400,
      fontSize: 'H300',
      lineHeight: 'normal',
      color: 't.black70',
    }}
  >
    {children}
  </Box>
);

const ApplyButton: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      right: 0,
      padding: '8px 12px',
      borderRadius: '4px',
      color: 't.white',
      background: 't.blue100',
      fontWeight: 600,
      fontSize: 'H300',
      lineHeight: 'normal',
      cursor: 'pointer',
    }}
    {...props}
  >
    {children}
  </Box>
);

const BrandVetBanner: FunctionComponent<BrandVetBannerProps> = ({
  onApply,
}) => {
  return (
    <Container>
      <IconContainer>
        <FontAwesomeIcon icon={faExclamation} />
      </IconContainer>
      <ContentContainer>
        <Title>Brand Vet Required</Title>
        <Message>
          The brand you've selected has not been vetted for RCS.
          <br />
          Click Apply for Vetting to request an RCS vet
        </Message>
        <ApplyButton onClick={onApply}>Apply for Vetting</ApplyButton>
      </ContentContainer>
    </Container>
  );
};

export default BrandVetBanner;
